// سرویس مدیریت محصولات نقش خیال

const API_BASE_URL = "/api";
const PRODUCTS_ENDPOINT = `${API_BASE_URL}/products`;

export const getProducts = async () => {
  const response = await fetch(PRODUCTS_ENDPOINT);

  if (!response.ok) {
    throw new Error("خطا در دریافت محصولات");
  }

  const products = await response.json();

  return Array.isArray(products) ? products : [];
};

export const getActiveProducts = async () => {
  const products = await getProducts();

  return products.filter((product) => product.isActive !== false);
};

export const getProductById = async (productId) => {
  const response = await fetch(`${PRODUCTS_ENDPOINT}/${productId}`);

  if (!response.ok) {
    throw new Error("محصول مورد نظر یافت نشد");
  }

  return response.json();
};

export const createProduct = async (productData) => {
  const now = new Date().toISOString();

  const newProduct = {
    title: productData.title?.trim() || "",
    img: productData.img?.trim() || "",
    price: Number(productData.price || 0),
    count: Number(productData.count || 0),
    description: productData.description?.trim() || "",
    category: productData.category?.trim() || "عمومی",
    isActive: productData.isActive !== false,
    createdAt: now,
    updatedAt: now,
  };

  const response = await fetch(PRODUCTS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(localStorage.getItem("authToken") ? { Authorization: `Bearer ${localStorage.getItem("authToken")}` } : {}),
    },
    body: JSON.stringify(newProduct),
  });

  if (!response.ok) {
    throw new Error("خطا در ایجاد محصول");
  }

  return response.json();
};

export const updateProduct = async (productId, updates) => {
  const cleanedUpdates = {
    ...updates,
    updatedAt: new Date().toISOString(),
  };

  if (cleanedUpdates.title !== undefined) {
    cleanedUpdates.title = cleanedUpdates.title.trim();
  }

  if (cleanedUpdates.img !== undefined) {
    cleanedUpdates.img = cleanedUpdates.img.trim();
  }

  if (cleanedUpdates.description !== undefined) {
    cleanedUpdates.description = cleanedUpdates.description.trim();
  }

  if (cleanedUpdates.category !== undefined) {
    cleanedUpdates.category = cleanedUpdates.category.trim() || "عمومی";
  }

  if (cleanedUpdates.price !== undefined) {
    cleanedUpdates.price = Number(cleanedUpdates.price || 0);
  }

  if (cleanedUpdates.count !== undefined) {
    cleanedUpdates.count = Number(cleanedUpdates.count || 0);
  }

  const response = await fetch(`${PRODUCTS_ENDPOINT}/${productId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...(localStorage.getItem("authToken") ? { Authorization: `Bearer ${localStorage.getItem("authToken")}` } : {}),
    },
    body: JSON.stringify(cleanedUpdates),
  });

  if (!response.ok) {
    throw new Error("خطا در ویرایش محصول");
  }

  return response.json();
};

export const activateProduct = async (productId) => {
  return updateProduct(productId, {
    isActive: true,
  });
};

export const deactivateProduct = async (productId) => {
  return updateProduct(productId, {
    isActive: false,
  });
};

export const deleteProduct = async (productId) => {
  const response = await fetch(`${PRODUCTS_ENDPOINT}/${productId}`, {
    method: "DELETE",
    headers: localStorage.getItem("authToken") ? { Authorization: `Bearer ${localStorage.getItem("authToken")}` } : {},
  });

  if (!response.ok) {
    throw new Error("خطا در حذف محصول");
  }

  return {
    success: true,
  };
};

export const uploadProductImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch("/api/media", {
    method: "POST",
    headers: localStorage.getItem("authToken") ? { Authorization: `Bearer ${localStorage.getItem("authToken")}` } : {},
    body: formData,
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || "خطا در بارگذاری تصویر");
  return result;
};
